import { createFormikValidation, sanitizeString } from "../../utils/Utils";

export const validateFormRegisterStep1 = (values) => {
  const map = new Map();

  map.set("razao_social", "razão social");
  map.set("cnpj", "CNPJ");
  map.set("email", "e-mail");
  map.set("telefone", "telefone");

  const errors = createFormikValidation(map, values);

  const telefone_raw = sanitizeString(values.telefone || "", false);
  if (!errors.telefone && telefone_raw.length > 0 && telefone_raw.length < 10) {
    errors.telefone = "O telefone deve conter 10 ou 11 dígitos.";
  }

  return errors;
};

export const validateFormRegisterStep2 = (values) => {
  const map = new Map();

  map.set("senha", "senha");
  map.set("senhaConfirm", "confirmação de senha");

  const errors = createFormikValidation(map, values);

  if (!errors.senha && values.senha && values.senha.length < 8) {
    errors.senha = "Sua senha não atende aos requisitos mínimos.";
  }

  if (!errors.senhaConfirm && values.senha !== values.senhaConfirm) {
    errors.senhaConfirm = "As senhas não coincidem.";
  }

  return errors;
};

export const getInitialValuesRegister = () => ({
  razao_social: "",
  cnpj: "",
  email: "",
  telefone: "",
  senha: "",
  senhaConfirm: "",
});

export const createFormRegister = (values) => {
  const cnpj_raw = sanitizeString(values.cnpj || "", false);
  const telefone_raw = sanitizeString(values.telefone || "", false);

  return {
    razao_social: (values.razao_social || "").trim(),
    cnpj: cnpj_raw,
    email: (values.email || "").trim(),
    telefone: telefone_raw,
    password: values.senha || "",
    password_confirmation: values.senhaConfirm || "",
  };
};

export const indexPage = () => "/auth/register";
